import { Injectable } from '@angular/core';
import { API_ROUTE_SUPPORTS_SEARCH } from '@app/forms/subscription/api/api-router';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Allocation } from '@app/dashboard/sheets/shared/ea-simulation-packs/simulation-pack.service';
import * as _ from 'lodash';
import { map, Observable } from 'rxjs';

export interface ArbitragePackResolvedLine {
  id: number;
  name: string;
  type: string;
  isin: string;
  details: any;
  allocationPercentage: number;
}

export interface ArbitragePackResolution {
  lines: ArbitragePackResolvedLine[];
  unresolvedIsins: string[];
}

@Injectable({ providedIn: 'root' })
export class ArbitragePackSupportsService {
  constructor(private httpApi: HttpApiService) {}

  resolve(
    allocation: Allocation[],
    productId: number,
  ): Observable<ArbitragePackResolution> {
    const isins = _.compact(_.map(allocation, 'supportIsin'));

    return this.httpApi
      .post(API_ROUTE_SUPPORTS_SEARCH, {
        page: 1,
        size: isins.length || 1,
        isins,
        lifeInsuranceId: productId,
        active: true,
        fillFullData: true,
      })
      .pipe(
        map((res: any) => {
          const supportsByIsin = _.keyBy(res?.content || [], 'isin');

          const lines: ArbitragePackResolvedLine[] = [];
          const unresolvedIsins: string[] = [];

          allocation.forEach((item: any) => {
            const support = supportsByIsin[item.supportIsin];
            if (!support) {
              unresolvedIsins.push(item.supportIsin);
              return;
            }
            lines.push({
              id: support.id,
              name: support.name,
              type: support.type,
              isin: support.isin,
              details: support.details,
              allocationPercentage: Number(item.allocationPercentage) || 0,
            });
          });

          return { lines, unresolvedIsins };
        }),
      );
  }
}
